/* eslint-disable no-dupe-keys */
export default {
  car: {
    name: '车辆认证',
    // 属性（一般与对象内容匹配）
    prop: {
      plate_location: '车牌归属地',
      plate_number: '车牌号码',
      usage: '使用性质',
      car_brand: '车品牌',
      car_type: '车型号',
      other_car_type: '其他车型',
      vin: 'VIN',
      user: '用户',
      audit_status: '认证状态',
      inserting_gun_start_count: '即插即充启动数',
      vin_start_count: 'VIN启动数',
      has_inserting_gun_start: '即插即充启动',
      has_vin_start: 'VIN启动',
      info_status: '车信息完善度',
      created_at: '登记时间',
      updated_at: '更新时间',
      status: '状态',
      last_vin_start_time: '最近VIN启动时间',
      last_inserting_gun_start_time: '最近即插即充启动时间',
      orders_count: '订单数',
      vin_records_count: 'VIN启动数',
      inserting_gun_start_records_count: '即插即充启动数'
    },
    // Enum的属性
    usages: {
      non_commercial: '非营运',
      commercial: '营运',
      other_usage: '其它'
    },
    audit_statuses: {
      unaudited: '未认证',
      audit_failed: '认证失败',
      audit_passed: '已认证'
    },
    audit_status_icons: {
      unaudited: 'lc-ico-uncertified',
      audit_failed: 'lc-ico-certify-failed',
      audit_passed: 'lc-ico-certified'
    },
    info_statuses: {
      missing_car_model: '缺失车型',
      has_car_model: '有车型',
      has_plate_number: '有车牌',
      has_vin: '有VIN'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询车牌号码/VIN',
      search_car_brand: '特斯拉/比亚迪/小鹏'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      orders: '订单',
      inserting_gun_start_records: '即插即充启动记录',
      vin_records: 'VIN启动记录'
    },
    titles: {
      base_info: '基本信息',
      vehicle_license: '机动车行驶证',
      activity_info: '活动信息'
    },
    labels: {
      total_non_commercial_count: '非营运车辆数',
      total_commercial_count: '营运车辆数',
      total_other_usage_count: '其他用途车辆数',
      total_car_model_count: '车型认证数',
      total_car_plate_count: '车牌认证数',
      total_car_model_missing_count: '车型缺失数',
      total_inserting_gun_start_count: '即插即充启动',
      total_vin_start_count: 'VIN启动'
    },
    tips: {
      audit_tip: '未认证的车辆将不能用于VIN 及 即插即充充电启动',
      has_deleted: '当前车辆信息已被删除，展示的信息为删除前的快照'
    }
  }
}
